<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ title }}</h2>

    <div mat-dialog-content>
        <form [formGroup]="recipientEditorForm">
            <div class="inputContainer">
                <label>Name</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Name" />
                    <mat-error *ngIf="name.invalid && name.touched && name.hasError('required')">Missing name.</mat-error>
                    <mat-error *ngIf="name.errors?.isNameTaken && name.touched">Name has already been taken.</mat-error>
                </mat-form-field>
            </div>

            <!-- <div class="inputContainer">
                <label>FirstName</label>
                <mat-form-field appearance="outline">
                    <input #firstName matInput type="text" formControlName="FirstName" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>MiddleName</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="MiddleName" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>LastName</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="LastName" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Nickname</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Nickname" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Prefix</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Prefix" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Suffix</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Suffix" />
                </mat-form-field>
            </div> -->

            <div class="inputContainer">
                <label>Email</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Email" />
                    <mat-error *ngIf="email.invalid && email.touched && email.hasError('required')">Missing email.</mat-error>
                </mat-form-field>
            </div>
            <!-- <div class="inputContainer">
                <label>Group</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Group" />
                    <mat-error *ngIf="group.invalid && group.touched && group.hasError('required')">Missing email.</mat-error>
                </mat-form-field>
            </div> -->
        </form>
    </div>

    <div class="spacer" fxFlex></div>

    <!-- <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
        <mat-error
            *ngIf="
                schoolEditorForm.controls['SchoolName'].invalid &&
                !schoolEditorForm.controls['SchoolName'].errors?.isNameTaken &&
                schoolEditorForm.controls['SchoolName'].touched
            "
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Please provide a name for the school.
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['SchoolName'].errors?.isNameTaken && schoolEditorForm.controls['SchoolName'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            School name chosen is already in use.
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['Phone'].errors?.maxlength && schoolEditorForm.controls['Phone'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['Phone'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['PhoneExt'].errors?.maxlength && schoolEditorForm.controls['PhoneExt'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['PhoneExt'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['Fax'].errors?.maxlength && schoolEditorForm.controls['Fax'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['Fax'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['_5digit'].errors?.maxlength && schoolEditorForm.controls['_5digit'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['_5digit'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['_5digit2'].errors?.maxlength && schoolEditorForm.controls['_5digit2'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['_5digit2'].errors?.maxlength.requiredLength }}
        </mat-error>
    </div> -->

    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit(recipientEditorForm.value)">Save</button>
        <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
    </div>
</div>
